export function shipNewToVisualString(shipNewString: string | null): string {

    if (shipNewString === null || shipNewString.length !== 4) {
        return '';
    }

    const monthPartString = shipNewString.substring(0, 2);
    const yearPartString = shipNewString.substring(2, 4);
    const monthPartNumber = Number(monthPartString);
    const yearPartNumber = Number(yearPartString);

    if (!isFinite(monthPartNumber) || !Number.isInteger(monthPartNumber) || monthPartNumber <= 0 || monthPartNumber > 12 || (monthPartNumber < 10 && monthPartString[0] !== '0')) {
        return '';
    }

    if (!isFinite(yearPartNumber) || !Number.isInteger(yearPartNumber) || yearPartNumber < 0 || yearPartNumber > 99 || (yearPartNumber < 10 && monthPartString[0] !== '0') || (yearPartNumber === 0 && yearPartString !== '00')) {
        return '';
    }

    let month = '';

    switch (monthPartNumber) {
        case 1:
            month = 'Jan';
            break;
        case 2:
            month = 'Feb';
            break;
        case 3:
            month = 'Mar';
            break;
        case 4:
            month = 'Apr';
            break;
        case 5:
            month = 'May';
            break;
        case 6:
            month = 'Jun';
            break;
        case 7:
            month = 'Jul';
            break;
        case 8:
            month = 'Aug';
            break;
        case 9:
            month = 'Sep';
            break;
        case 10:
            month = 'Oct';
            break;
        case 11:
            month = 'Nov';
            break;
        case 12:
            month = 'Dec';
            break;
    }

    return month + ' ' + yearPartString;
}